import { render, staticRenderFns } from "./SuspiciousActivityTransactions.vue?vue&type=template&id=2c51e8ba&scoped=true&"
import script from "./SuspiciousActivityTransactions.vue?vue&type=script&lang=js&"
export * from "./SuspiciousActivityTransactions.vue?vue&type=script&lang=js&"
import style0 from "./SuspiciousActivityTransactions.vue?vue&type=style&index=0&id=2c51e8ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c51e8ba",
  null
  
)

component.options.__file = "SuspiciousActivityTransactions.vue"
export default component.exports